// @flow
import { fork } from 'redux-saga/effects';
import setRateSaga from './setRate';
import getTrialSaga from './getTrial';

export default function* gameSaga() {
  yield fork(setRateSaga);
  yield fork(getTrialSaga);
}
